<div class="traffic-form no-gutters me-md-5 me-0" *transloco="let t">
  <form class="col" [formGroup]="trafficForm" (ngSubmit)="onSubmit()">
    <div class="row no-gutters">
      <div class="col-md col-12">
        <div class="row no-gutters">
          <div class="form-group col-12">
            <label for="kindergartenOperationType">{{ t('settings/kindergartenOperationType') }}*</label>
            <ng-select
              id="kindergartenOperationType"
              formControlName="kindergartenOperationType"
              [items]="kindergartenOperationType"
              bindLabel="value"
              bindValue="text"
              [placeholder]="t('child/select')"
              class="form-control"
            >
            </ng-select>
          </div>
          <div class="form-group col-12">
            <label for="avgHalfDayHours">
              {{ t('settings/avgHalfDayHours') }}*&nbsp;<i
                [class]="iconService.warning"
                placement="top"
                [ngbTooltip]="t('settings/avgInfo')"
              ></i>
            </label>
            <input id="avgHalfDayHours" formControlName="avgHalfDayHours" class="form-control form-control-lg" type="number" />
          </div>
          <div class="form-group col-12">
            <label for="avgBoardingHours">
              {{ t('settings/avgBoardingHours') }}*&nbsp;<i
                [class]="iconService.warning"
                placement="top"
                [ngbTooltip]="t('settings/avgInfo')"
              ></i>
            </label>
            <input id="avgBoardingHours" formControlName="avgBoardingHours" class="form-control form-control-lg" type="number" />
          </div>
        </div>
      </div>
      <div class="col-md col-12 mt-md-0 mt-4">
        <div class="row no-gutters">
          <div class="form-group col-12">
            <label for="distinction">{{ t('settings/distinction') }}*</label>
            <ng-select
              id="distinction"
              formControlName="distinction"
              [items]="distinction"
              bindLabel="text"
              bindValue="value"
              [placeholder]="t('settings/selectDistinction')"
              class="form-control"
            >
            </ng-select>
          </div>
          <div class="form-group col-12">
            <label for="avgFullDayHours">
              {{ t('settings/avgFullDayHours') }}*&nbsp;<i
                [class]="iconService.warning"
                placement="top"
                [ngbTooltip]="t('settings/avgInfo')"
              ></i>
            </label>
            <input id="avgFullDayHours" formControlName="avgFullDayHours" class="form-control form-control-lg" type="number" />
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="row no-gutters" formGroupName="contactPerson">
      <div class="col-12">
        <h2>{{ t('settings/contactPerson') }}</h2>
        <p>{{ t('settings/contactPersonDetail') }}</p>
      </div>
      <div class="col-md col-12">
        <div class="row no-gutters">
          <div class="form-group col-12">
            <label for="name"> {{ t('settings/nameSurname') }}*</label>
            <input id="name" formControlName="name" class="form-control form-control-lg" type="text" />
          </div>
          <div class="form-group col-12">
            <label for="phone"> {{ t('closeRelative/phone') }}*</label>
            <input id="phone" formControlName="phone" class="form-control form-control-lg" type="text" />
          </div>
        </div>
      </div>
      <div class="col-md col-12 mt-md-0 mt-4">
        <div class="row no-gutters">
          <div class="form-group col-12">
            <label for="email"> {{ t('user/email') }}*</label>
            <input id="email" formControlName="email" class="form-control form-control-lg" type="email" />
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="row no-gutters">
      <div class="d-flex justify-content-end col">
        <button class="btn btn-lg btn-primary" [disabled]="trafficForm.invalid">
          {{ t('shared/save') }}
        </button>
      </div>
    </div>
  </form>
</div>
